"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.propertySearchType = exports.estimatedAvmType = void 0;

var _propTypes = _interopRequireDefault(require("prop-types"));

var propertySearchType = _propTypes.default.shape({
  corelogicPropertyId: _propTypes.default.string,
  streetAddress: _propTypes.default.string,
  streetName: _propTypes.default.string,
  addressMode: _propTypes.default.string,
  houseNumber: _propTypes.default.string,
  houseNumber2: _propTypes.default.string,
  city: _propTypes.default.string,
  state: _propTypes.default.string,
  streetSuffix: _propTypes.default.string,
  postDirection: _propTypes.default.string,
  unitNumber: _propTypes.default.string,
  zipCode: _propTypes.default.string,
  zip4: _propTypes.default.string,
  longitude: _propTypes.default.number,
  latitude: _propTypes.default.number,
  fipsCode: _propTypes.default.string,
  preDirection: _propTypes.default.string,
  parcelNumber: _propTypes.default.string,
  parcelSequence: _propTypes.default.string,
  carrierRoute: _propTypes.default.string,
  apn: _propTypes.default.string,
  universalParcelId: _propTypes.default.string,
  houseNumberSuffix: _propTypes.default.string,
  county: _propTypes.default.string
});

exports.propertySearchType = propertySearchType;

var estimatedAvmType = _propTypes.default.shape({
  avmValue: _propTypes.default.number,
  landUseCode: _propTypes.default.number,
  runDate: _propTypes.default.string,
  lastSaleDate: _propTypes.default.string,
  lastSaleValue: _propTypes.default.number
});

exports.estimatedAvmType = estimatedAvmType;